import { InputProps, SelectInput } from "react-admin"

import { salutationChoices } from "../constants"

export const SelectSalutationInput: React.FC<InputProps> = (props) => (
  <SelectInput {...props} choices={salutationChoices} />
)
